<template>
	<div class="modal-container">
		<div class="modal-wrapper">
			<div class="warning-container incomplete-member-modal">
				<div class="warning-modal-title">
					{{ $tc('modals.wizardRedirect.title') }}
				</div>
				<div class="warning-modal-body">
					{{ $tc('modals.wizardRedirect.notOrderCompletedText[0]') }} <br> {{
						$tc('modals.wizardRedirect.notOrderCompletedText[1]') }}
				</div>
				<p class="font-medium">
					{{ countdown }}
				</p>
				<div class="mt-5">
					<a v-if="showRedirect" class="button-light-blue opacity-hover" href="/my/plans/">
						{{ $tc('modals.wizardRedirect.redirectText') }}
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'

export default {
	name: 'ModalWizardRedirect',
	mixins: [ModalMixin],
	data: () => ({
		countdown: 5,
		timer: null,
		showRedirect: true
	}),
	mounted () {
		this.timer = setInterval(this.timerFunction.bind(this), 1000)
	},
	beforeDestroy () {
		clearInterval(this.timer)
	},
	methods: {
		timerFunction () {
			if (this.countdown <= 0) {
				window.location.href = '/my/plans/'
			} else {
				this.countdown -= 1
			}
		}
	}
}
</script>

<style lang="scss">
.modal-container {
	position: absolute;
	display: flex;
	height: 100%;
	width: 100%;

	.modal-mask {
		position: absolute;
		z-index: 100;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.3);
		/*display: table;*/
		transition: opacity 0.3s ease;
	}
}

.modal-wrapper {
	display: flex;
	width: 100%;
	align-items: center;
	justify-content: center;
	z-index: 101;
}

.warning-container {
	width: 371px;
	height: 250px;
	margin: 0px auto;
	background-color: #fff;
	border-radius: 2px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
	transition: all 0.3s ease;
	border: #EEEEEE solid 6px;
	display: flex;
	flex-direction: column;
	align-items: center;

	@include respond-below(phone) {
		width: calc(100% - 32px);
	}

	.warning-modal-title {
		margin-top: 50px;
		margin-bottom: 14px;
		font-size: 12px;
		line-height: 14px;
		color: #B70101;
		text-align: center;
		width: 240px;
	}

	.warning-modal-body {
		font-size: 12px;
		line-height: 16px;
		color: #1E1E1E;
		text-align: center;
		margin-bottom: 10px;
	}

	.warning-btn {
		width: 127px;
		height: 21px;
		font-size: 10px;
		letter-spacing: 1.4px;
		padding: 0;
		margin-top: 10px;
	}
}

.warning-container.incomplete-member-modal {
	width: 371px;
	height: 250px;
	margin: 0px auto;
	background-color: #fff;
	border-radius: 2px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
	transition: all 0.3s ease;
	border: #EEEEEE solid 6px;
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;

	.modal-close {
		position: absolute;
		right: 10px;
		font-size: 24px;
		cursor: pointer;
		color: #000000;
	}

	@include respond-below(phone) {
		width: calc(100% - 32px);
	}

	.warning-modal-title {
		font-family: 'Rubik';
		font-weight: bold;
		margin-top: 30px;
		margin-bottom: 28px;
		font-size: 24px;
		line-height: 14px;
		color: #000000;
		text-align: center;
		width: 240px;
	}

	.warning-modal-body {
		font-family: 'Rubik';
		font-weight: normal;
		font-size: 11px;
		line-height: 14px;
		color: #000000;
		text-align: center;
		margin-bottom: 10px;
		width: 292px;
	}
}
</style>
